import { render, staticRenderFns } from "./tree-modal.vue?vue&type=template&id=c42c3a02"
import script from "./tree-modal.vue?vue&type=script&lang=ts"
export * from "./tree-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports